import { useEffect } from 'react';

const useTwoCol = () => {
  useEffect(() => {
    if (typeof document !== 'undefined') {
      function resizeComponent(id) {
        var imageElement = document.querySelector(
          '#' + id + ' .c-full-width-two-col-text-img__content__fields__image'
        );
        var viewportWidth = window.innerWidth;

        if (imageElement) {
          var imageSmall = imageElement.getAttribute('data-bg-image-small');
          var imageMedium = imageElement.getAttribute('data-bg-image-medium');
          var imageLarge = imageElement.getAttribute('data-bg-image-large');
          var bgStyle = 'display: none;';

          if (!imageMedium) {
            imageMedium = imageLarge;
          }

          if (!imageSmall) {
            imageSmall = imageLarge;
          }

          if (viewportWidth <= 1023 && viewportWidth >= 768 && imageMedium) {
            bgStyle = "background-image: url('" + imageMedium + "')";
          } else if (viewportWidth < 768 && imageSmall) {
            bgStyle = "background-image: url('" + imageSmall + "')";
          }

          if (imageElement.getAttribute('style') != bgStyle) {
            imageElement.setAttribute('style', bgStyle);
          }
        }
      }

      var widgets = document.getElementsByClassName('c-full-width-two-col-text-img');
      for (var i = 0; i < widgets.length; i++) {
        var widget = widgets[i];
        var widgetClass = widget.getAttribute('class');
        var id = widget.getAttribute('id');
        if (widgetClass && widgetClass.indexOf('display-image') !== -1) {
          var resize = function () {
            resizeComponent(id);
          };
          window.addEventListener('resize', resize);
          resize();
        }
      }
    }
  }, []);
};

export default useTwoCol;
